<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-primary">
        <h4 class="card-title">User Guide</h4>
        <p class="card-category">How to use the FishyHub merchant portal.</p>
      </div>
      <div class="card-body">
        <a mat-stroked-button color="primary" [href]="openUrl" target="_blank" rel="noopener">
          <mat-icon>open_in_new</mat-icon>
          Open PDF in a new tab
        </a>

        <!--
          A static src, so Angular does not need to be told to trust a bound
          resource URL. /preview is the Drive view meant for embedding; /view
          refuses to be framed.
        -->
        <div class="user-guide-box">
          <iframe
            src="https://drive.google.com/file/d/130_UVqFnUywFPbPn-3R676W29N5eyisQ/preview"
            title="FishyHub merchant user guide"
            class="user-guide-frame"
            allow="autoplay"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

